import React from "react";
import { connect } from "react-redux";
import { callService } from "../tools";

const mapState = (state) => {
	return {
		paso: state.af.pasoInvitado,
		familiar: state.af.familiar,
		listaPolizas: state.af.listaPolizas,
		uid: state.global.uid,
		tid: state.global.tid,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		pasoInvitado: (paso) => {
			dispatch({ "type": "AF_EDITAR_PASO_INVITADO", "pasoInvitado": paso });
		},		
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class AgregarPolizas extends React.Component {
	state = {
		polizasIds: [],
		vigenciaIds: {}
	}

	cancelar = () => {
		let $this = this;
		$this.props.loader(true);
		$this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_COMPARTIR-CANCELAR", "dispositivo": $this.props.dispositivo });
		let llamaServicio = new callService({
			service: "accesoFamiliar.eliminarFamiliar",
			token: this.props.tid,
			data: {
				familiar: this.props.familiar.id
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.pasoInvitado(0);
			$this.props.loader(false);
			$("#modal-invitar").modal("toggle");
		}).catch((error) => {
			console.log("error", error);
			$this.props.loader(false);
			$("#modal-invitar").modal("toggle");
		});
	}

	guardar = () => {
		let $this = this;
		$this.props.loader(true);
		
		let llamaServicio = new callService({
			service: "accesoFamiliar.editarFamiliar",
			secure: true,
			data: {
				familiar: this.props.familiar.id,
				polizas: this.state.polizasIds,
				vigencias: this.state.vigenciaIds
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.pasoInvitado(2);
			$this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_COMPARTIR-ENVIAR", "dispositivo": $this.props.dispositivo });
			$this.props.loader(false);
		}).catch((error) => {
			console.log("error", error);
			$this.props.loader(false);
			$this.props.alerta(error.message.mensaje);
		});
	}

	valida = () => {
		if(this.state.polizasIds.length > 0) {
			this.guardar();
		} else {
			this.props.alerta("Selecciona una o mas pólizas.");
		}
	}

	handleChangeChk = (_item, event) => {
		let polizas = this.state.polizasIds;
		let vigencia = this.state.vigenciaIds;
		
		if(event.target.checked) {
			polizas.push(_item.generales.numPoliza);
			vigencia[_item.generales.numPoliza] = _item.generales.fchVigenciaInicial.split("/").reverse().join("");
		} else {
			let eliminar = polizas.indexOf(_item.generales.numPoliza); 
			if (eliminar != -1) {
				polizas.splice(eliminar,1);
			}
		}
		
		this.setState({polizasIds: polizas, vigenciaIds: vigencia});
	}

	render() {
		return <div>
			<h5><i><img src={ require("../img/documentos-icono.png") } /></i>Compartir pólizas</h5>
			<div className="row">
				<div className="col-xs-12 mb-20">
					<div className="texto-17 blue-text">
						<p>Selecciona la póliza o pólizas a las cuales quieres dar acceso a tu invitado, recuerda que podrá reportar siniestros, solicitar asistencia vial y consultar información de las pólizas.</p>
					</div>
					<div className="overflow-wrap mt-25">
						<ul>
							{ this.props.listaPolizas.map((item, i) => {
								return (
									<li key={i} className="clearfix">
										<div className="col-xs-6" style={{"padding":"0 5px"}}>
											<h6>{item.vehiculo.descripcion}</h6>
											<p>
												<i className="center-icon"><img src={ require("../img/icon-poliza.png") } /></i>
												Póliza N: {item.generales.numPoliza}
											</p>
										</div>
										<div className="col-xs-4 text-right" style={{"padding":"0 5px"}}>
											<h6><b>{item.vehiculo.placas}</b></h6>
											<p style={{"color":"#183d7b"}}>MODELO {item.vehiculo.modelo}</p>
										</div>
										<div className="col-xs-2" style={{"padding":"0 5px", "textAlign":"center"}}>
											<div className="checkbox-blue text-center">
												<input type="checkbox" onChange={this.handleChangeChk.bind(this, item)} />
												<label></label>
											</div>
										</div>
									</li>
								);
							})}
						</ul>
					</div>
					<div className="text-center aceptar-cancelar-btn mt-75">
						<a onClick={this.cancelar.bind(this)}>Cancelar</a>
						<a onClick={this.valida.bind(this)} className="orange-btn">Enviar</a>
					</div>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(AgregarPolizas);


// WEBPACK FOOTER //
// ./src/acceso-familiar/AgregarPolizas.cmpt.js